import { navigate } from "gatsby";

const RESOURCE_WIKI_PREFIXES = [
  "/guides",
  "/blog",
  "/resources",
  "/reports",
  "/downloadable-resource",
  "/wiki",
];

/** Paths served by the main Gatsby app (not resource/wiki). */
const MAIN_SITE_PREFIXES = [
  "/demo",
  "/signup",
  "/pricing",
  "/login",
  "/performance-management-system",
  "/attendance-management-software",
  "/employee-self-service-portal",
  "/middle-east/demo",
  "/middle-east/signup",
  "/indonesia/demo",
];

export const toAbsoluteUrl = (path) => {
  if (!path) return "";
  if (typeof window === "undefined") return path;
  if (/^https?:\/\//i.test(path)) return path;
  return `${window.location.origin}${path.startsWith("/") ? path : `/${path}`}`;
};

export const isResourceOrWikiPath = (pathname = "") =>
  RESOURCE_WIKI_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );

export const isMainSitePath = (path = "") => {
  const pathname = path.split("?")[0].split("#")[0];
  return MAIN_SITE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
};

/** Full document navigation — required when leaving resource/wiki for main-site routes. */
export const assignToUrl = (path) => {
  if (typeof window === "undefined" || !path) return;
  window.location.assign(toAbsoluteUrl(path));
};

/**
 * Use Gatsby client routing on the same app; force a full load when crossing apps
 * so /demo/ keeps query params and CloudFront serves the correct bundle.
 */
export const navigateCrossApp = (path) => {
  if (!path) return;
  if (typeof window === "undefined") {
    navigate(path);
    return;
  }

  const onResourceOrWiki = isResourceOrWikiPath(window.location.pathname);
  if (onResourceOrWiki && isMainSitePath(path)) {
    assignToUrl(path);
    return;
  }

  navigate(path);
};
